import {
  CLINICAL_SEVERITY_GUIDE,
  NON_CLINICAL_SEVERITY_GUIDE,
  getSeverityGuide,
  isRcaRequired,
  RCA_RULES_SUMMARY
} from './severityGuideData';

// ==========================================================
// ค่าคงที่ระบบ
// ==========================================================

export const WAREHOUSES_LIST = [
  { name: "คลังใหญ่ (คลังพัสดุ)", order: 1 }, 
  { name: "คลังย่อย (คลังห้องฟัน)", order: 2 }, 
  { name: "ห้องเก็บของ", order: 3 },
  { name: "ห้องคลีนิก", order: 4 },
  { name: "   - ห้อง sterile", order: 5 },
  { name: "   - คลีนิกห้อง 1", order: 6 }, 
  { name: "   - คลีนิกห้อง 2", order: 7 }, 
  { name: "   - คลีนิกห้อง 3", order: 8 },
  { name: "   - คลีนิกห้อง 4", order: 9 }, 
  { name: "   - คลีนิกห้อง 5", order: 10 }, 
  { name: "   - คลีนิกห้อง 6", order: 11 },
  { name: "   - คลีนิกห้อง 7", order: 12 }, 
  { name: "   - ห้องอื่นๆ (PCU, ออกหน่วย)", order: 13 }, 
  { name: "   - ห้อง OR", order: 14 },
  { name: "   - เรือนจำ", order: 15 }, 
  { name: "   - กำลัง sterile", order: 16 }, 
  { name: "   - ห้องล้างเครื่องมือ", order: 17 }
];

export const CONSUMABLE_WAREHOUSES = [
  "คลังใหญ่ (คลังพัสดุ)",
  "คลังย่อย (คลังห้องฟัน)",
  "ห้องเก็บของ",
  "ห้องคลีนิก"
];

// สิทธิ์ผู้ใช้ที่กำหนดเป็น admin
export const ADMIN_EMAILS = ['nuntsak@gmail.com', 'nuntsak@hotmail.com'];

export const getUserRole = (email) => {
  if (ADMIN_EMAILS.includes(email)) return 'admin';
  return 'อื่นๆ';
};

// รายการสาขาทันตกรรมเฉพาะทาง สำหรับจำแนกวัสดุสิ้นเปลือง
export const DENTAL_SPECIALTIES = [
  { id: 'operative', name: 'งานอุดฟัน', code: 'OP', color: '#0284c7' },
  { id: 'prosthodontics', name: 'งานพรอส', code: 'PROS', color: '#7c3aed' },
  { id: 'implant', name: 'งานรากเทียม', code: 'IMP', color: '#d97706' },
  { id: 'orthodontics', name: 'งานจัดฟัน', code: 'ORTHO', color: '#db2777' },
  { id: 'endodontics', name: 'งานเอนโด', code: 'ENDO', color: '#dc2626' },
  { id: 'oral_surgery', name: 'งานศัลยศาสตร์ช่องปาก', code: 'SURG', color: '#ea580c' },
  { id: 'periodontics', name: 'งานปริทันต์', code: 'PERIO', color: '#059669' },
  { id: 'general', name: 'ทันตกรรมทั่วไป/อื่นๆ', code: 'GEN', color: '#4b5563' }
];

// ==========================================================
// การบริหารจัดการความเสี่ยงทางทันตกรรม (Dental Risk Management)
// ==========================================================

export const DENTAL_RISK_DOMAINS = [
  { id: 'clinical', label: 'ความเสี่ยงทางคลินิก (Clinical Risk)', color: '#2563eb', icon: '🩺' },
  { id: 'cssd', label: 'งานจ่ายกลางและฆ่าเชื้อ (CSSD Risk)', color: '#0d9488', icon: '🧼' },
  { id: 'non_clinical', label: 'ความเสี่ยงทั่วไป/สิ่งแวดล้อม (Non-Clinical Risk)', color: '#ea580c', icon: '🏢' }
];

export const CLINICAL_SEVERITY_LEVELS = CLINICAL_SEVERITY_GUIDE;
export const NON_CLINICAL_SEVERITY_LEVELS = NON_CLINICAL_SEVERITY_GUIDE;
export { CLINICAL_SEVERITY_GUIDE, NON_CLINICAL_SEVERITY_GUIDE, getSeverityGuide, isRcaRequired, RCA_RULES_SUMMARY };


export const DENTAL_RISK_CATEGORIES = {
  clinical: [
    {
      category: 'เครื่องมือและอุปกรณ์ทางการแพทย์',
      subCategories: [
        'หัวกรอ / ด้ามกรอแตกหักชำรุด',
        'ตะไบหักในคลองรากฟัน (Broken file)',
        'แผลไหม้จากด้ามหัวกรอ (Burn injury)',
        'อุปกรณ์หลุดร่วงในช่องปาก',
        'เครื่องขูดหินปูน / ปลายทิปหักหรือชำรุด',
        'อุปกรณ์ตรวจรักษาชำรุดขณะใช้งาน'
      ]
    },
    {
      category: 'การควบคุมการติดเชื้อและการสเตอไรล์ (Infection Control)',
      subCategories: [
        'หีบห่อบรรจุภัณฑ์ฉีกขาด / Seal เสื่อมสภาพ',
        'ตัวบ่งชี้เคมี/ชีวภาพไม่เปลี่ยนสี (Sterilization Failure)',
        'พบความชื้นหรือหยดน้ำในซองเครื่องมือหลังนึ่ง (Wet Pack)',
        'ล้างคราบเลือด/สารคัดหลั่งไม่สะอาดก่อนแพ็ก',
        'เครื่องมือนึ่งหมดอายุแต่ถูกนำไปเตรียมใช้งาน',
        'น้ำในระบบยูนิตทำฟันปนเปื้อน',
        'อุบัติเหตุของมีคม / เข็มตำบุคลากร (Needle Stick Injury)'
      ]
    },
    {
      category: 'ภาวะแทรกซ้อนจากการรักษาทางทันตกรรม',
      subCategories: [
        'ตะไบหักในคลองรากฟัน (Broken file)',
        'สิ่งแปลกปลอมหลุดลงคอ/สำลัก (Foreign Body Ingestion/Aspiration)',
        'ภาวะพิษจากยาชา (LAST - Local Anesthetic Systemic Toxicity)',
        'แผลไหม้จากด้ามหัวกรอ (Handpiece Burn Injury)',
        'ถอนฟันผิดซี่ (Wrong Tooth Extraction)',
        'ไซนัสทะลุ (OAC - Oroantral Communication)',
        'เนื้อเยื่ออ่อนฉีกขาด / บาดเจ็บลิ้น-กระพุ้งแก้ม',
        'เลือดออกไม่หยุดหลังถอนฟัน/ผ่าฟันคุด (Prolonged bleeding)',
        'กระดูกขากรรไกรหัก / ข้อต่อขากรรไกรเลื่อน',
        'ชาถาวรหรือบาดเจ็บเส้นประสาท (Nerve damage)',
        'ทะลุโพรงประสาทฟันโดยไม่ได้ตั้งใจ'
      ]
    },
    {
      category: 'การใช้ยาและสารเคมีทางทันตกรรม',
      subCategories: [
        'ภาวะพิษจากยาชา (LAST)',
        'ผู้ป่วยเกิดอาการแพ้ยาชา / แพ้ยารุนแรง (Anaphylaxis)',
        'ยาชาออกฤทธิ์ผิดปกติ / เข้าหลอดเลือด (Intravascular injection)',
        'สารกัดกร่อน (Etchant/Sodium Hypochlorite) สัมผัสเนื้อเยื่ออ่อนหรือตา',
        'สั่งจ่ายยาผิดชนิด / ผิดขนาด / ผู้ป่วยมีประวัติแพ้ยา',
        'ใช้สารเคมีหรือน้ำยาฟอกสีฟันหกเลอะผู้ป่วย'
      ]
    },
    {
      category: 'การระบุตัวผู้ป่วยและตำแหน่งหัตถการ',
      subCategories: [
        'ถอนฟันผิดซี่ (Wrong Tooth Extraction)',
        'อุดฟันหรือทำหัตถการผิดซี่',
        'ระบุตัวผู้ป่วยผิดคน (Wrong Patient)',
        'เอกซเรย์ผิดตำแหน่ง / บันทึกชาร์ตสลับคน'
      ]
    },
    {
      category: 'ภาวะฉุกเฉินทางการแพทย์ในคลินิก',
      subCategories: [
        'ผู้ป่วยเป็นลมหมดสติ (Vasovagal Syncope)',
        'ภาวะน้ำตาลในเลือดต่ำ (Hypoglycemia)',
        'ความดันโลหิตสูงวิกฤต / แน่นหน้าอก (Hypertensive crisis/Angina)',
        'ผู้ป่วยชักเกร็ง / หยุดหายใจ'
      ]
    }
  ],
  cssd: [
    {
      category: 'การล้มเหลวของกระบวนการฆ่าเชื้อ (Sterilization Failure)',
      subCategories: [
        'สปอร์เทสต์เป็นบวก (BI positive / Biological Indicator Positive)',
        'Bowie-Dick ล้มเหลว (Bowie-Dick Test Failure)',
        'เครื่องนึ่งขัดข้อง/ตัดกลางคัน (Sterilizer Cycle Aborted)',
        'ตัวบ่งชี้เคมีไม่เปลี่ยนสี (Chemical Indicator Failure - Class 4/5/6)',
        'อุณหภูมิ/ความดัน/เวลาในรอบนึ่งไม่ได้มาตรฐาน',
        'ระบบสุญญากาศ (Vacuum) ในเครื่องนึ่งขัดข้อง'
      ]
    },
    {
      category: 'บรรจุภัณฑ์และการจัดเก็บ (Packaging & Storage)',
      subCategories: [
        'ซองเปียกชื้น (Wet pack / Moisture detected)',
        'รอยซีลแตก/หลุดร่อน (Seal Integrity Breach)',
        'ของมีคมทิ่มทะลุซอง (Pouch Puncture by Sharp Instrument)',
        'เครื่องมือหมดอายุ (Sterility Expired / Outdated Shelf Life)',
        'ซองบรรจุภัณฑ์ฉีกขาดระหว่างขนส่งหรือจัดเก็บ',
        'ฉลากรอบนึ่งหรือบาร์โค้ดเลือนรางไม่ชัดเจน'
      ]
    },
    {
      category: 'การล้างและทำลายเชื้อ (Cleaning & Decontamination)',
      subCategories: [
        'พบคราบเลือด/โปรตีนตกค้างในท่อ/ข้อต่อ (Bioburden Residue)',
        'เครื่องอัลตราโซนิกขัดข้อง (Ultrasonic Cleaner Malfunction)',
        'น้ำ RO ค่าความนำไฟฟ้าเกิน (RO Water High Conductivity)',
        'น้ำยาทำความสะอาด/เอนไซม์เจือจางผิดสัดส่วน',
        'การทดสอบประสิทธิภาพการล้างไม่ผ่าน (Cleaning verification failed)',
        'เครื่องล้างอัตโนมัติ (Washer-Disinfector) ขัดข้อง'
      ]
    },
    {
      category: 'สภาพและความครบถ้วนของเครื่องมือ (Instrument Integrity)',
      subCategories: [
        'เครื่องมือในเซ็ตไม่ครบ (Missing instruments in set)',
        'ชำรุด/บิ่น/ปลายหัก/ข้อต่อหลวม (Damaged/Chipped instruments)',
        'ขึ้นสนิม/ผุกร่อน (Corrosion / Rust)',
        'จัดเครื่องมือผิดประเภทหรือผิดเซ็ต (Wrong Instrument Assembly)',
        'ป้ายระบุรหัสหรือบาร์โค้ดชำรุด / สแกนไม่ติด'
      ]
    }
  ],
  non_clinical: [
    {
      category: 'ความปลอดภัยและสิ่งแวดล้อม (Safety & Environment)',
      subCategories: [
        'อุบัติเหตุของมีคม / เข็มตำบุคลากร (Needle Stick Injury)',
        'สารคัดหลั่งหรือเลือดกระเด็นใส่ตา/ผิวหนัง (Splash injury)',
        'ลื่นหกล้ม / สะดุดสายไฟในคลินิก',
        'สารเคมีอันตรายหกหล่นรั่วซึม',
        'อุปกรณ์ดับเพลิงหรือทางหนีไฟมีสิ่งกีดขวาง'
      ]
    },
    {
      category: 'ระบบสาธารณูปโภคและโครงสร้างพื้นฐาน',
      subCategories: [
        'อุปกรณ์/ยูนิตทำฟันขัดข้อง (Dental Unit Malfunction)',
        'ไฟฟ้าดับ / ระบบสำรองไฟขัดข้อง',
        'ระบบจ่ายน้ำประปา / น้ำ RO ขัดข้อง',
        'ระบบลม Dental Air Compressor ดับ/รั่วซึม',
        'ระบบดูดเสมหะส่วนกลาง (Central Suction) ขัดข้อง',
        'เครื่องปรับอากาศหรือระบบระบายอากาศชำรุด'
      ]
    },
    {
      category: 'ระบบสารสนเทศและเวชระเบียน',
      subCategories: [
        'ระบบเครือข่ายอินเทอร์เน็ตล่ม ไม่สามารถดูชาร์ตได้',
        'ข้อมูลเวชระเบียนสูญหายหรือไม่ซิงค์',
        'เครื่องคอมพิวเตอร์ประจำยูนิตดับขณะลงข้อมูล'
      ]
    },
    {
      category: 'การบริการและข้อร้องเรียน',
      subCategories: [
        'พฤติกรรมบริการหรือการสื่อสารขัดแย้ง',
        'การรอคอยคิวนานเกินเกณฑ์มาตรฐาน',
        'ทรัพย์สินของผู้ป่วยสูญหาย'
      ]
    }
  ]
};

// Aliases and Subsets for Convenience
export const CSSD_RISK_CATEGORIES = DENTAL_RISK_CATEGORIES.cssd;

// ==========================================================
// หมวดหมู่ผังก้างปลาสำหรับการวิเคราะห์หาสาเหตุที่แท้จริง (RCA Fishbone Categories)
// ==========================================================
export const RCA_FISHBONE_CATEGORIES = [
  {
    id: 'people',
    name: 'People (คน / บุคลากร)',
    englishName: 'People',
    icon: '👥',
    color: '#3b82f6',
    description: 'ปัจจัยด้านทักษะ ความรู้ การสื่อสาร ภาระงาน หรือความเหนื่อยล้าของบุคลากร',
    factors: [
      'ความเหนื่อยล้า / ภาระงานมากเกินไป (Fatigue / High Workload)',
      'ขาดการฝึกอบรม / ประสบการณ์หรือทักษะไม่เพียงพอ (Training & Competency)',
      'การสื่อสารคลาดเคลื่อนในทีม (Communication Breakdown)',
      'ไม่ปฏิบัติตามมาตรฐานหรือข้ามขั้นตอน (Non-compliance / Workaround)',
      'ปัจจัยจากผู้ป่วย (Patient Factors: กังวล, กลืนน้ำลาย, ขยับศีรษะ)'
    ]
  },
  {
    id: 'process',
    name: 'Process (กระบวนการ / วิธีปฏิบัติงาน)',
    englishName: 'Process',
    icon: '📋',
    color: '#10b981',
    description: 'ปัจจัยด้านขั้นตอนการทำงาน แนวทางปฏิบัติ คู่มือ หรือระบบตรวจสอบซ้ำ',
    factors: [
      'แนวทางปฏิบัติ (SOP / Guideline) ไม่ชัดเจนหรือไม่เป็นปัจจุบัน',
      'ขาดขั้นตอนการตรวจสอบซ้ำสองคน (Double Check Verification)',
      'การระบุตัวตน / ฉลาก / บาร์โค้ดผิดพลาด (Identification & Labeling)',
      'ขั้นตอนการส่งต่อเครื่องมือหรือข้อมูลไม่ต่อเนื่อง (Handover Process)',
      'ไม่มีระบบเตือนเมื่อเครื่องมือหมดอายุหรือไม่พร้อมใช้ (Tracking & Recall Failure)'
    ]
  },
  {
    id: 'equipment',
    name: 'Equipment (เครื่องมือ / อุปกรณ์ / เครื่องจักร)',
    englishName: 'Equipment',
    icon: '⚙️',
    color: '#f59e0b',
    description: 'ปัจจัยด้านสภาพเครื่องมือ การชำรุด การเสื่อมสภาพ หรือการบำรุงรักษา',
    factors: [
      'เครื่องมือชำรุด / เสื่อมสภาพตามอายุการใช้งาน (Metal Fatigue / Wear & Tear)',
      'เครื่องนึ่ง / เครื่องล้าง / เครื่องซีลขัดข้อง (Machine Malfunction)',
      'ขาดการบำรุงรักษาเชิงป้องกันตามรอบ (Lack of Preventive Maintenance - PM)',
      'อุปกรณ์ไม่เพียงพอหรือไม่พร้อมใช้งาน (Equipment Shortage)',
      'การสอบเทียบค่าอุณหภูมิ/ความดันไม่ได้มาตรฐาน (Calibration Drift)'
    ]
  },
  {
    id: 'environment',
    name: 'Environment (สิ่งแวดล้อม / สถานที่ / สาธารณูปโภค)',
    englishName: 'Environment',
    icon: '🏢',
    color: '#8b5cf6',
    description: 'ปัจจัยด้านกายภาพ สถานที่ทำงาน แสงสว่าง เสียง ระบบน้ำ ระบบลม',
    factors: [
      'พื้นที่ทำงานคับแคบ / การยศาสตร์ไม่เหมาะสม (Ergonomics / Workspace Layout)',
      'แสงสว่าง / อุณหภูมิ / ความชื้นในห้องไม่ได้เกณฑ์มาตรฐาน (Lighting & Climate)',
      'เสียงรบกวนหรือสิ่งรบกวนสมาธิขณะปฏิบัติงาน (Distractions)',
      'ระบบสาธารณูปโภคขัดข้อง (น้ำประปา, น้ำ RO, ระบบลม Compressor, ไฟฟ้าดับ)',
      'พื้นเปียกลื่น / สิ่งกีดขวางในพื้นที่ปฏิบัติงาน (Slip / Trip Hazards)'
    ]
  }
];

export const getLocalDateTimeString = (dateObj = new Date()) => {
  const d = new Date(dateObj);
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

/**
 * รายการเหตุการณ์ความเสี่ยงทันตกรรมและงานจ่ายกลางแบบครอบคลุม (Comprehensive Dental & CSSD Incidents)
 * อ้างอิงตามเกณฑ์ความปลอดภัยทันตกรรมสภา (Thai Dental Council 2P Safety / DSG 2024 / CDC / WHO)
 * ครอบคลุม 5 หมวดหลัก 70 รายการ พร้อมระดับความรุนแรง (Level A-I / Level 1-5)
 */
export const COMPREHENSIVE_DENTAL_INCIDENTS = [
  // ==========================================
  // หมวด 1: คลินิก & หัตถการ (Clinical & Operative)
  // ==========================================
  {
    id: 'broken-file',
    tag: 'ตะไบหักในคลองรากฟัน (Broken file)',
    domain: 'clinical',
    group: 'clinical',
    severity_level: 'E',
    severity_score: 3,
    category: 'ภาวะแทรกซ้อนจากการรักษาทางทันตกรรม',
    sub_category: 'ตะไบหักในคลองรากฟัน (Broken file)',
    location: 'คลีนิกห้อง 1',
    is_patient_involved: false,
    is_frequent: true,
    keywords: ['ตะไบ', 'หัก', 'คลองราก', 'endo', 'file', 'broken', 'ฟัน']
  },
  {
    id: 'wrong-tooth',
    tag: 'ถอนฟันผิดซี่ (Wrong Tooth Extraction)',
    domain: 'clinical',
    group: 'clinical',
    severity_level: 'F',
    severity_score: 3,
    category: 'การระบุตัวผู้ป่วยและตำแหน่งหัตถการ',
    sub_category: 'ถอนฟันผิดซี่ (Wrong Tooth Extraction)',
    location: 'คลีนิกห้อง 1',
    is_patient_involved: false,
    is_frequent: true,
    keywords: ['ถอนฟัน', 'ผิดซี่', 'สลับซี่', 'extraction', 'wrong tooth']
  },
  {
    id: 'wrong-tooth-restoration',
    tag: 'อุดฟันหรือทำหัตถการผิดซี่',
    domain: 'clinical',
    group: 'clinical',
    severity_level: 'E',
    severity_score: 3,
    category: 'การระบุตัวผู้ป่วยและตำแหน่งหัตถการ',
    sub_category: 'อุดฟันหรือทำหัตถการผิดซี่',
    location: 'คลีนิกห้อง 1',
    is_patient_involved: false,
    is_frequent: false,
    keywords: ['อุดฟัน', 'ผิดซี่', 'ผิดตำแหน่ง', 'filling', 'restoration']
  },
  {
    id: 'wrong-patient',
    tag: 'ระบุตัวผู้ป่วยผิดคน (Wrong Patient)',
    domain: 'clinical',
    group: 'clinical',
    severity_level: 'E',
    severity_score: 3,
    category: 'การระบุตัวผู้ป่วยและตำแหน่งหัตถการ',
    sub_category: 'ระบุตัวผู้ป่วยผิดคน (Wrong Patient)',
    location: 'ห้องตรวจประเมิน / คัดกรอง',
    is_patient_involved: false,
    is_frequent: false,
    keywords: ['สลับคน', 'ผิดคน', 'คนไข้', 'patient', 'wrong patient']
  },
  {
    id: 'aspiration-foreign-body',
    tag: 'สิ่งแปลกปลอมหลุดลงคอ/สำลัก (Aspiration)',
    domain: 'clinical',
    group: 'clinical',
    severity_level: 'F',
    severity_score: 3,
    category: 'ภาวะแทรกซ้อนจากการรักษาทางทันตกรรม',
    sub_category: 'สิ่งแปลกปลอมหลุดลงคอ/สำลัก (Foreign Body Ingestion/Aspiration)',
    location: 'คลีนิกห้อง 1',
    is_patient_involved: false,
    is_frequent: true,
    keywords: ['กลืน', 'สำลัก', 'หลุดลงคอ', 'aspiration', 'swallow', 'foreign body']
  },
  {
    id: 'oroantral-communication',
    tag: 'ไซนัสทะลุ (OAC - Oroantral Communication)',
    domain: 'clinical',
    group: 'clinical',
    severity_level: 'E',
    severity_score: 3,
    category: 'ภาวะแทรกซ้อนจากการรักษาทางทันตกรรม',
    sub_category: 'ไซนัสทะลุ (OAC - Oroantral Communication)',
    location: 'คลีนิกห้อง 1',
    is_patient_involved: false,
    is_frequent: true,
    keywords: ['ไซนัส', 'ทะลุ', 'oac', 'sinus', 'oroantral']
  },
  {
    id: 'prolonged-bleeding',
    tag: 'เลือดออกไม่หยุดหลังถอนฟัน/ผ่าฟันคุด',
    domain: 'clinical',
    group: 'clinical',
    severity_level: 'E',
    severity_score: 3,
    category: 'ภาวะแทรกซ้อนจากการรักษาทางทันตกรรม',
    sub_category: 'เลือดออกไม่หยุดหลังถอนฟัน/ผ่าฟันคุด (Prolonged bleeding)',
    location: 'คลีนิกห้อง 1',
    is_patient_involved: false,
    is_frequent: true,
    keywords: ['เลือดออก', 'ไม่หยุด', 'bleeding', 'hemorrhage', 'ถอนฟัน', 'ผ่าฟันคุด']
  },
  {
    id: 'soft-tissue-laceration',
    tag: 'เนื้อเยื่ออ่อนฉีกขาด/หัวกรอบาดลิ้น-กระพุ้งแก้ม',
    domain: 'clinical',
    group: 'clinical',
    severity_level: 'E',
    severity_score: 3,
    category: 'ภาวะแทรกซ้อนจากการรักษาทางทันตกรรม',
    sub_category: 'เนื้อเยื่ออ่อนฉีกขาด / บาดเจ็บลิ้น-กระพุ้งแก้ม',
    location: 'คลีนิกห้อง 1',
    is_patient_involved: false,
    is_frequent: true,
    keywords: ['ฉีกขาด', 'บาด', 'ลิ้น', 'กระพุ้งแก้ม', 'soft tissue', 'laceration', 'ฉีก']
  },
  {
    id: 'nerve-injury',
    tag: 'ชาถาวรหรือเส้นประสาทได้รับบาดเจ็บ (Nerve damage)',
    domain: 'clinical',
    group: 'clinical',
    severity_level: 'G',
    severity_score: 4,
    category: 'ภาวะแทรกซ้อนจากการรักษาทางทันตกรรม',
    sub_category: 'ชาถาวรหรือบาดเจ็บเส้นประสาท (Nerve damage)',
    location: 'คลีนิกห้อง 1',
    is_patient_involved: false,
    is_frequent: false,
    keywords: ['ชา', 'เส้นประสาท', 'nerve', 'paresthesia', 'permanent', 'ian']
  },
  {
    id: 'accidental-pulp-exposure',
    tag: 'ทะลุโพรงประสาทฟันโดยไม่ได้ตั้งใจ',
    domain: 'clinical',
    group: 'clinical',
    severity_level: 'E',
    severity_score: 3,
    category: 'ภาวะแทรกซ้อนจากการรักษาทางทันตกรรม',
    sub_category: 'ทะลุโพรงประสาทฟันโดยไม่ได้ตั้งใจ',
    location: 'คลีนิกห้อง 1',
    is_patient_involved: false,
    is_frequent: false,
    keywords: ['ทะลุ', 'โพรงประสาท', 'pulp exposure', 'accidental', 'กรอฟัน']
  },
  {
    id: 'jaw-fracture-dislocation',
    tag: 'กระดูกขากรรไกรหัก/ข้อต่อขากรรไกรเลื่อน',
    domain: 'clinical',
    group: 'clinical',
    severity_level: 'F',
    severity_score: 3,
    category: 'ภาวะแทรกซ้อนจากการรักษาทางทันตกรรม',
    sub_category: 'กระดูกขากรรไกรหัก / ข้อต่อขากรรไกรเลื่อน',
    location: 'คลีนิกห้อง 1',
    is_patient_involved: false,
    is_frequent: false,
    keywords: ['ขากรรไกร', 'หัก', 'กรามค้าง', 'tmj', 'jaw', 'dislocation', 'fracture']
  },
  {
    id: 'handpiece-burn',
    tag: 'แผลไหม้จากด้ามหัวกรอ (Handpiece Burn)',
    domain: 'clinical',
    group: 'clinical',
    severity_level: 'E',
    severity_score: 3,
    category: 'เครื่องมือและอุปกรณ์ทางการแพทย์',
    sub_category: 'แผลไหม้จากด้ามหัวกรอ (Burn injury)',
    location: 'คลีนิกห้อง 1',
    is_patient_involved: false,
    is_frequent: true,
    keywords: ['ไหม้', 'ร้อน', 'หัวกรอ', 'burn', 'handpiece', 'แผลไหม้']
  },
  {
    id: 'broken-handpiece',
    tag: 'หัวกรอหัก/ด้ามกรอชำรุดขณะใช้งาน',
    domain: 'clinical',
    group: 'clinical',
    severity_level: 'D',
    severity_score: 2,
    category: 'เครื่องมือและอุปกรณ์ทางการแพทย์',
    sub_category: 'หัวกรอ / ด้ามกรอแตกหักชำรุด',
    location: 'คลีนิกห้อง 1',
    is_patient_involved: false,
    is_frequent: true,
    keywords: ['หัวกรอ', 'หัก', 'ชำรุด', 'handpiece', 'broken', 'แตก']
  },
  {
    id: 'bur-loosened',
    tag: 'หัวกรอ Bur หลุดร่วงในช่องปาก',
    domain: 'clinical',
    group: 'clinical',
    severity_level: 'D',
    severity_score: 2,
    category: 'เครื่องมือและอุปกรณ์ทางการแพทย์',
    sub_category: 'อุปกรณ์หลุดร่วงในช่องปาก',
    location: 'คลีนิกห้อง 1',
    is_patient_involved: false,
    is_frequent: false,
    keywords: ['bur', 'หลุด', 'ร่วง', 'ช่องปาก', 'diamond', 'คาร์ไบด์']
  },
  {
    id: 'scaler-tip-fracture',
    tag: 'ปลายทิปเครื่องขูดหินปูนหัก',
    domain: 'clinical',
    group: 'clinical',
    severity_level: 'D',
    severity_score: 2,
    category: 'เครื่องมือและอุปกรณ์ทางการแพทย์',
    sub_category: 'เครื่องขูดหินปูน / ปลายทิปหักหรือชำรุด',
    location: 'คลีนิกห้อง 1',
    is_patient_involved: false,
    is_frequent: false,
    keywords: ['ขูดหินปูน', 'ปลายหัก', 'scaler tip', 'ultrasonic', 'ทิปหัก']
  },
  {
    id: 'rubber-dam-tear',
    tag: 'ยางแผ่นกันน้ำลายฉีกขาดขณะรักษา',
    domain: 'clinical',
    group: 'clinical',
    severity_level: 'C',
    severity_score: 2,
    category: 'เครื่องมือและอุปกรณ์ทางการแพทย์',
    sub_category: 'อุปกรณ์ตรวจรักษาชำรุดขณะใช้งาน',
    location: 'คลีนิกห้อง 1',
    is_patient_involved: false,
    is_frequent: false,
    keywords: ['ยางกันน้ำลาย', 'ฉีก', 'rubber dam', 'tear', 'แคลมป์หลุด']
  },
  {
    id: 'xray-wrong-chart',
    tag: 'เอกซเรย์ผิดตำแหน่ง/ชาร์ตสลับคน',
    domain: 'clinical',
    group: 'clinical',
    severity_level: 'B',
    severity_score: 1,
    category: 'การระบุตัวผู้ป่วยและตำแหน่งหัตถการ',
    sub_category: 'เอกซเรย์ผิดตำแหน่ง / บันทึกชาร์ตสลับคน',
    location: 'ห้อง X-Ray / CT',
    is_patient_involved: false,
    is_frequent: false,
    keywords: ['xray', 'เอกซเรย์', 'สลับคน', 'ผิดตำแหน่ง', 'chart', 'ฟิล์ม']
  },
  {
    id: 'root-tip-displacement',
    tag: 'รากฟันหักตกค้างในเบ้าฟัน/ไซนัส',
    domain: 'clinical',
    group: 'clinical',
    severity_level: 'E',
    severity_score: 3,
    category: 'ภาวะแทรกซ้อนจากการรักษาทางทันตกรรม',
    sub_category: 'ภาวะแทรกซ้อนจากการรักษาทางทันตกรรม',
    location: 'คลีนิกห้อง 1',
    is_patient_involved: false,
    is_frequent: false,
    keywords: ['รากหัก', 'ตกค้าง', 'รากฟัน', 'root tip', 'displacement', 'ตกค้าง']
  },
  {
    id: 'postop-severe-infection',
    tag: 'แผลติดเชื้อรุนแรงหลังทำหัตถการ',
    domain: 'clinical',
    group: 'clinical',
    severity_level: 'F',
    severity_score: 3,
    category: 'ภาวะแทรกซ้อนจากการรักษาทางทันตกรรม',
    sub_category: 'ภาวะแทรกซ้อนจากการรักษาทางทันตกรรม',
    location: 'คลีนิกห้อง 1',
    is_patient_involved: false,
    is_frequent: false,
    keywords: ['ติดเชื้อ', 'หนอง', 'บวม', 'infection', 'abscess', 'cellulitis']
  },
  {
    id: 'subcutaneous-emphysema',
    tag: 'ลมแทรกใต้ผิวหนังขณะผ่าตัด (Emphysema)',
    domain: 'clinical',
    group: 'clinical',
    severity_level: 'F',
    severity_score: 3,
    category: 'ภาวะแทรกซ้อนจากการรักษาทางทันตกรรม',
    sub_category: 'ภาวะแทรกซ้อนจากการรักษาทางทันตกรรม',
    location: 'คลีนิกห้อง 1',
    is_patient_involved: false,
    is_frequent: false,
    keywords: ['ลมแทรก', 'บวมลม', 'emphysema', 'subcutaneous', 'หัวกรอลม']
  },

  // ==========================================
  // หมวด 2: จ่ายกลาง & ฆ่าเชื้อ (CSSD & Sterilization)
  // ==========================================
  {
    id: 'bi-positive',
    tag: 'สปอร์เทสต์เป็นบวก (BI positive)',
    domain: 'cssd',
    group: 'cssd',
    severity_level: 'D',
    severity_score: 2,
    category: 'การล้มเหลวของกระบวนการฆ่าเชื้อ (Sterilization Failure)',
    sub_category: 'สปอร์เทสต์เป็นบวก (BI positive / Biological Indicator Positive)',
    location: 'ห้องจ่ายกลาง (CSSD)',
    is_patient_involved: false,
    is_frequent: true,
    keywords: ['สปอร์', 'bi', 'positive', 'biological', 'ฆ่าเชื้อไม่ผ่าน', 'บวก']
  },
  {
    id: 'bowie-dick-fail',
    tag: 'Bowie-Dick ล้มเหลว',
    domain: 'cssd',
    group: 'cssd',
    severity_level: 'B',
    severity_score: 1,
    category: 'การล้มเหลวของกระบวนการฆ่าเชื้อ (Sterilization Failure)',
    sub_category: 'Bowie-Dick ล้มเหลว (Bowie-Dick Test Failure)',
    location: 'ห้องจ่ายกลาง (CSSD)',
    is_patient_involved: false,
    is_frequent: true,
    keywords: ['bowie dick', 'โบวี่ดิก', 'สุญญากาศ', 'vacuum', 'test fail']
  },
  {
    id: 'wet-pack',
    tag: 'ซองเปียกชื้น (Wet pack)',
    domain: 'cssd',
    group: 'cssd',
    severity_level: 'B',
    severity_score: 1,
    category: 'บรรจุภัณฑ์และการจัดเก็บ (Packaging & Storage)',
    sub_category: 'ซองเปียกชื้น (Wet pack / Moisture detected)',
    location: 'ห้องจ่ายกลาง (CSSD)',
    is_patient_involved: false,
    is_frequent: true,
    keywords: ['เปียก', 'ชื้น', 'wet pack', 'moisture', 'หยดน้ำ', 'ซองเปียก']
  },
  {
    id: 'seal-integrity-breach',
    tag: 'รอยซีลแตก/หลุดร่อน',
    domain: 'cssd',
    group: 'cssd',
    severity_level: 'B',
    severity_score: 1,
    category: 'บรรจุภัณฑ์และการจัดเก็บ (Packaging & Storage)',
    sub_category: 'รอยซีลแตก/หลุดร่อน (Seal Integrity Breach)',
    location: 'ห้องจ่ายกลาง (CSSD)',
    is_patient_involved: false,
    is_frequent: true,
    keywords: ['ซีลแตก', 'หลุดร่อน', 'seal', 'ซองเปิด', 'รอยซีล']
  },
  {
    id: 'pouch-puncture',
    tag: 'ของมีคมทิ่มทะลุซอง',
    domain: 'cssd',
    group: 'cssd',
    severity_level: 'B',
    severity_score: 1,
    category: 'บรรจุภัณฑ์และการจัดเก็บ (Packaging & Storage)',
    sub_category: 'ของมีคมทิ่มทะลุซอง (Pouch Puncture by Sharp Instrument)',
    location: 'ห้องจ่ายกลาง (CSSD)',
    is_patient_involved: false,
    is_frequent: true,
    keywords: ['ทิ่มทะลุ', 'ของมีคม', 'ซองขาด', 'puncture', 'pouch', 'เข็มทิ่ม']
  },
  {
    id: 'bioburden-residue',
    tag: 'พบคราบเลือด/โปรตีนตกค้าง',
    domain: 'cssd',
    group: 'cssd',
    severity_level: 'C',
    severity_score: 2,
    category: 'การล้างและทำลายเชื้อ (Cleaning & Decontamination)',
    sub_category: 'พบคราบเลือด/โปรตีนตกค้างในท่อ/ข้อต่อ (Bioburden Residue)',
    location: 'จุดล้างและทำลายเชื้อ',
    is_patient_involved: false,
    is_frequent: true,
    keywords: ['คราบเลือด', 'โปรตีนตกค้าง', 'ล้างไม่สะอาด', 'bioburden', 'blood', 'ตกค้าง']
  },
  {
    id: 'ci-failure',
    tag: 'ตัวบ่งชี้เคมีไม่เปลี่ยนสี (CI Failure)',
    domain: 'cssd',
    group: 'cssd',
    severity_level: 'C',
    severity_score: 2,
    category: 'การล้มเหลวของกระบวนการฆ่าเชื้อ (Sterilization Failure)',
    sub_category: 'ตัวบ่งชี้เคมีไม่เปลี่ยนสี (Chemical Indicator Failure - Class 4/5/6)',
    location: 'ห้องจ่ายกลาง (CSSD)',
    is_patient_involved: false,
    is_frequent: true,
    keywords: ['ci', 'indicator', 'เคมี', 'ไม่เปลี่ยนสี', 'chemical indicator']
  },
  {
    id: 'autoclave-abort',
    tag: 'Autoclave ฟาวล์/ตัดกลางคัน',
    domain: 'cssd',
    group: 'cssd',
    severity_level: 'B',
    severity_score: 1,
    category: 'การล้มเหลวของกระบวนการฆ่าเชื้อ (Sterilization Failure)',
    sub_category: 'เครื่องนึ่งขัดข้อง/ตัดกลางคัน (Sterilizer Cycle Aborted)',
    location: 'ห้องจ่ายกลาง (CSSD)',
    is_patient_involved: false,
    is_frequent: true,
    keywords: ['ฟาวล์', 'autoclave', 'ตัดรอบ', 'เครื่องนึ่ง', 'cycle aborted', 'ความดันตก']
  },
  {
    id: 'missing-instruments',
    tag: 'เครื่องมือไม่ครบเซ็ต',
    domain: 'cssd',
    group: 'cssd',
    severity_level: 'B',
    severity_score: 1,
    category: 'สภาพและความครบถ้วนของเครื่องมือ (Instrument Integrity)',
    sub_category: 'เครื่องมือในเซ็ตไม่ครบ (Missing instruments in set)',
    location: 'ห้องจ่ายกลาง (CSSD)',
    is_patient_involved: false,
    is_frequent: true,
    keywords: ['ไม่ครบเซ็ต', 'หาย', 'เครื่องมือหาย', 'missing', 'set', 'ขาด']
  },
  {
    id: 'corrosion-rust',
    tag: 'เครื่องมือชำรุด/ขึ้นสนิม',
    domain: 'cssd',
    group: 'cssd',
    severity_level: 'B',
    severity_score: 1,
    category: 'สภาพและความครบถ้วนของเครื่องมือ (Instrument Integrity)',
    sub_category: 'ขึ้นสนิม/ผุกร่อน (Corrosion / Rust)',
    location: 'ห้องจ่ายกลาง (CSSD)',
    is_patient_involved: false,
    is_frequent: true,
    keywords: ['สนิม', 'ชำรุด', 'ผุกร่อน', 'rust', 'corrosion', 'บิ่น', 'หัก']
  },
  {
    id: 'outdated-sterile-pack',
    tag: 'เครื่องมือนึ่งหมดอายุ (Outdated)',
    domain: 'cssd',
    group: 'cssd',
    severity_level: 'C',
    severity_score: 2,
    category: 'บรรจุภัณฑ์และการจัดเก็บ (Packaging & Storage)',
    sub_category: 'เครื่องมือหมดอายุ (Sterility Expired / Outdated Shelf Life)',
    location: 'คลังพัสดุและเวชภัณฑ์ทันตกรรม',
    is_patient_involved: false,
    is_frequent: false,
    keywords: ['หมดอายุ', 'outdated', 'shelf life', 'expired', 'ค้างสต็อก']
  },
  {
    id: 'ro-water-conductivity',
    tag: 'น้ำ RO ค่าความนำไฟฟ้าเกินเกณฑ์',
    domain: 'cssd',
    group: 'cssd',
    severity_level: 'B',
    severity_score: 1,
    category: 'การล้างและทำลายเชื้อ (Cleaning & Decontamination)',
    sub_category: 'น้ำ RO ค่าความนำไฟฟ้าเกิน (RO Water High Conductivity)',
    location: 'ห้องจ่ายกลาง (CSSD)',
    is_patient_involved: false,
    is_frequent: false,
    keywords: ['ro', 'น้ำro', 'conductivity', 'ความนำไฟฟ้า', 'น้ำกลั่น']
  },
  {
    id: 'ultrasonic-cleaner-fail',
    tag: 'เครื่องอัลตราโซนิกขัดข้อง',
    domain: 'cssd',
    group: 'cssd',
    severity_level: 'B',
    severity_score: 1,
    category: 'การล้างและทำลายเชื้อ (Cleaning & Decontamination)',
    sub_category: 'เครื่องอัลตราโซนิกขัดข้อง (Ultrasonic Cleaner Malfunction)',
    location: 'จุดล้างและทำลายเชื้อ',
    is_patient_involved: false,
    is_frequent: false,
    keywords: ['ultrasonic', 'อัลตราโซนิก', 'เครื่องล้าง', 'ไม่สั่น']
  },
  {
    id: 'enzymatic-detergent-dilution',
    tag: 'น้ำยาเอนไซม์เจือจางผิดสัดส่วน',
    domain: 'cssd',
    group: 'cssd',
    severity_level: 'B',
    severity_score: 1,
    category: 'การล้างและทำลายเชื้อ (Cleaning & Decontamination)',
    sub_category: 'น้ำยาทำความสะอาด/เอนไซม์เจือจางผิดสัดส่วน',
    location: 'จุดล้างและทำลายเชื้อ',
    is_patient_involved: false,
    is_frequent: false,
    keywords: ['เอนไซม์', 'น้ำยาเจือจาง', 'ผิดสัดส่วน', 'detergent', 'enzyme']
  },
  {
    id: 'cleaning-verification-failed',
    tag: 'การทดสอบประสิทธิภาพการล้างไม่ผ่าน',
    domain: 'cssd',
    group: 'cssd',
    severity_level: 'B',
    severity_score: 1,
    category: 'การล้างและทำลายเชื้อ (Cleaning & Decontamination)',
    sub_category: 'การทดสอบประสิทธิภาพการล้างไม่ผ่าน (Cleaning verification failed)',
    location: 'จุดล้างและทำลายเชื้อ',
    is_patient_involved: false,
    is_frequent: false,
    keywords: ['ทดสอบการล้าง', 'protein test', 'wash check', 'verification', 'ล้างไม่ผ่าน']
  },
  {
    id: 'wrong-set-assembly',
    tag: 'จัดเครื่องมือผิดประเภท/สลับเซ็ต',
    domain: 'cssd',
    group: 'cssd',
    severity_level: 'B',
    severity_score: 1,
    category: 'สภาพและความครบถ้วนของเครื่องมือ (Instrument Integrity)',
    sub_category: 'จัดเครื่องมือผิดประเภทหรือผิดเซ็ต (Wrong Instrument Assembly)',
    location: 'ห้องจ่ายกลาง (CSSD)',
    is_patient_involved: false,
    is_frequent: false,
    keywords: ['จัดผิดเซ็ต', 'สลับเซ็ต', 'ผิดประเภท', 'assembly', 'สลับซอง']
  },
  {
    id: 'damaged-barcode-label',
    tag: 'บาร์โค้ดหรือฉลากรอบนึ่งชำรุด',
    domain: 'cssd',
    group: 'cssd',
    severity_level: 'A',
    severity_score: 1,
    category: 'สภาพและความครบถ้วนของเครื่องมือ (Instrument Integrity)',
    sub_category: 'ป้ายระบุรหัสหรือบาร์โค้ดชำรุด / สแกนไม่ติด',
    location: 'ห้องจ่ายกลาง (CSSD)',
    is_patient_involved: false,
    is_frequent: false,
    keywords: ['บาร์โค้ด', 'ฉลากเลือน', 'barcode', 'label', 'สแกนไม่ติด', 'ฉลากขาด']
  },
  {
    id: 'pouch-torn-transit',
    tag: 'ซองบรรจุภัณฑ์ฉีกขาดระหว่างขนส่ง',
    domain: 'cssd',
    group: 'cssd',
    severity_level: 'B',
    severity_score: 1,
    category: 'บรรจุภัณฑ์และการจัดเก็บ (Packaging & Storage)',
    sub_category: 'ซองบรรจุภัณฑ์ฉีกขาดระหว่างขนส่งหรือจัดเก็บ',
    location: 'ห้องจ่ายกลาง (CSSD)',
    is_patient_involved: false,
    is_frequent: false,
    keywords: ['ซองขาด', 'ขนส่ง', 'ฉีกขาด', 'transport', 'ฉีก']
  },
  {
    id: 'vacuum-leak-rate',
    tag: 'ระบบสุญญากาศเครื่องนึ่งรั่ว (Vacuum Leak)',
    domain: 'cssd',
    group: 'cssd',
    severity_level: 'B',
    severity_score: 1,
    category: 'การล้มเหลวของกระบวนการฆ่าเชื้อ (Sterilization Failure)',
    sub_category: 'ระบบสุญญากาศ (Vacuum) ในเครื่องนึ่งขัดข้อง',
    location: 'ห้องจ่ายกลาง (CSSD)',
    is_patient_involved: false,
    is_frequent: false,
    keywords: ['vacuum leak', 'สุญญากาศรั่ว', 'รั่ว', 'leak rate', 'เครื่องนึ่ง']
  },
  {
    id: 'missing-internal-ci',
    tag: 'ไม่ได้ใส่ตัวบ่งชี้เคมีภายในซอง/ห่อ',
    domain: 'cssd',
    group: 'cssd',
    severity_level: 'B',
    severity_score: 1,
    category: 'การล้มเหลวของกระบวนการฆ่าเชื้อ (Sterilization Failure)',
    sub_category: 'ตัวบ่งชี้เคมีไม่เปลี่ยนสี (Chemical Indicator Failure - Class 4/5/6)',
    location: 'ห้องจ่ายกลาง (CSSD)',
    is_patient_involved: false,
    is_frequent: false,
    keywords: ['ลืมใส่แถบวัด', 'missing ci', 'internal indicator', 'แถบเคมี']
  },

  // ==========================================
  // หมวด 3: ยา สารเคมี & ภาวะฉุกเฉิน (Medication & Emergencies)
  // ==========================================
  {
    id: 'last-toxicity',
    tag: 'ภาวะพิษจากยาชา (LAST)',
    domain: 'clinical',
    group: 'emergency_pharma',
    severity_level: 'G',
    severity_score: 4,
    category: 'การใช้ยาและสารเคมีทางทันตกรรม',
    sub_category: 'ภาวะพิษจากยาชา (LAST)',
    location: 'คลีนิกห้อง 1',
    is_patient_involved: false,
    is_frequent: true,
    keywords: ['ยาชา', 'last', 'พิษยาชา', 'local anesthetic toxicity', 'หูแว่ว', 'ชาลิ้น']
  },
  {
    id: 'anaphylaxis',
    tag: 'ผู้ป่วยแพ้ยาชา/แพ้ยารุนแรง (Anaphylaxis)',
    domain: 'clinical',
    group: 'emergency_pharma',
    severity_level: 'H',
    severity_score: 5,
    category: 'การใช้ยาและสารเคมีทางทันตกรรม',
    sub_category: 'ผู้ป่วยเกิดอาการแพ้ยาชา / แพ้ยารุนแรง (Anaphylaxis)',
    location: 'คลีนิกห้อง 1',
    is_patient_involved: false,
    is_frequent: true,
    keywords: ['แพ้ยา', 'anaphylaxis', 'ช็อก', 'ผื่นคัน', 'หายใจไม่ออก', 'บวม', 'ยาชา']
  },
  {
    id: 'intravascular-injection',
    tag: 'ยาชาออกฤทธิ์เข้าหลอดเลือด (Intravascular)',
    domain: 'clinical',
    group: 'emergency_pharma',
    severity_level: 'E',
    severity_score: 3,
    category: 'การใช้ยาและสารเคมีทางทันตกรรม',
    sub_category: 'ยาชาออกฤทธิ์ผิดปกติ / เข้าหลอดเลือด (Intravascular injection)',
    location: 'คลีนิกห้อง 1',
    is_patient_involved: false,
    is_frequent: true,
    keywords: ['ยาชา', 'เข้าหลอดเลือด', 'ใจสั่น', 'intravascular', 'หัวใจเต้นเร็ว']
  },
  {
    id: 'chemical-corrosion-splash',
    tag: 'สารเคมี/กรดกัดกร่อน (Etchant/NaOCl)',
    domain: 'clinical',
    group: 'emergency_pharma',
    severity_level: 'D',
    severity_score: 2,
    category: 'การใช้ยาและสารเคมีทางทันตกรรม',
    sub_category: 'สารกัดกร่อน (Etchant/Sodium Hypochlorite) สัมผัสเนื้อเยื่ออ่อนหรือตา',
    location: 'คลีนิกห้อง 1',
    is_patient_involved: false,
    is_frequent: true,
    keywords: ['กรด', 'กัด', 'naocl', 'etchant', 'โซเดียมไฮโปคลอไรต์', 'แสบ', 'โดนตา']
  },
  {
    id: 'vasovagal-syncope',
    tag: 'ผู้ป่วยเป็นลม/วูบ (Vasovagal Syncope)',
    domain: 'clinical',
    group: 'emergency_pharma',
    severity_level: 'D',
    severity_score: 2,
    category: 'ภาวะฉุกเฉินทางการแพทย์ในคลินิก',
    sub_category: 'ผู้ป่วยเป็นลมหมดสติ (Vasovagal Syncope)',
    location: 'คลีนิกห้อง 1',
    is_patient_involved: false,
    is_frequent: true,
    keywords: ['เป็นลม', 'วูบ', 'หมดสติ', 'syncope', 'หน้ามืด', 'ตัวเย็น']
  },
  {
    id: 'hypoglycemia',
    tag: 'ภาวะน้ำตาลในเลือดต่ำ (Hypoglycemia)',
    domain: 'clinical',
    group: 'emergency_pharma',
    severity_level: 'E',
    severity_score: 3,
    category: 'ภาวะฉุกเฉินทางการแพทย์ในคลินิก',
    sub_category: 'ภาวะน้ำตาลในเลือดต่ำ (Hypoglycemia)',
    location: 'คลีนิกห้อง 1',
    is_patient_involved: false,
    is_frequent: false,
    keywords: ['น้ำตาลต่ำ', 'hypoglycemia', 'เหงื่อแตก', 'เบาหวาน', 'มือสั่น']
  },
  {
    id: 'hypertensive-crisis',
    tag: 'ความดันโลหิตสูงวิกฤต/แน่นหน้าอก',
    domain: 'clinical',
    group: 'emergency_pharma',
    severity_level: 'G',
    severity_score: 4,
    category: 'ภาวะฉุกเฉินทางการแพทย์ในคลินิก',
    sub_category: 'ความดันโลหิตสูงวิกฤต / แน่นหน้าอก (Hypertensive crisis/Angina)',
    location: 'คลีนิกห้อง 1',
    is_patient_involved: false,
    is_frequent: false,
    keywords: ['ความดันสูง', 'แน่นหน้าอก', 'angina', 'hypertension', 'วิกฤต', 'bp สูง']
  },
  {
    id: 'seizure-arrest',
    tag: 'ผู้ป่วยชักเกร็ง/หมดสติ',
    domain: 'clinical',
    group: 'emergency_pharma',
    severity_level: 'H',
    severity_score: 5,
    category: 'ภาวะฉุกเฉินทางการแพทย์ในคลินิก',
    sub_category: 'ผู้ป่วยชักเกร็ง / หยุดหายใจ',
    location: 'คลีนิกห้อง 1',
    is_patient_involved: false,
    is_frequent: false,
    keywords: ['ชัก', 'เกร็ง', 'seizure', 'convulsion', 'หมดสติ', 'หยุดหายใจ']
  },
  {
    id: 'medication-error',
    tag: 'สั่งจ่ายยาผิดชนิด/ผิดขนาด',
    domain: 'clinical',
    group: 'emergency_pharma',
    severity_level: 'E',
    severity_score: 3,
    category: 'การใช้ยาและสารเคมีทางทันตกรรม',
    sub_category: 'สั่งจ่ายยาผิดชนิด / ผิดขนาด / ผู้ป่วยมีประวัติแพ้ยา',
    location: 'คลีนิกห้อง 1',
    is_patient_involved: false,
    is_frequent: false,
    keywords: ['จ่ายยาผิด', 'ผิดขนาด', 'ขนาดยา', 'medication error', 'แพ้ยาซ้ำ']
  },
  {
    id: 'bleaching-chemical-burn',
    tag: 'น้ำยาฟอกสีฟันหกเลอะเนื้อเยื่อ',
    domain: 'clinical',
    group: 'emergency_pharma',
    severity_level: 'C',
    severity_score: 2,
    category: 'การใช้ยาและสารเคมีทางทันตกรรม',
    sub_category: 'ใช้สารเคมีหรือน้ำยาฟอกสีฟันหกเลอะผู้ป่วย',
    location: 'คลีนิกห้อง 1',
    is_patient_involved: false,
    is_frequent: false,
    keywords: ['ฟอกสีฟัน', 'bleaching', 'ไฮโดรเจนเปอร์ออกไซด์', 'ไหม้เหงือก', 'เหงือกขาว']
  },
  {
    id: 'naocl-extrusion',
    tag: 'โซเดียมไฮโปคลอไรต์ทะลุปลายราก (NaOCl Accident)',
    domain: 'clinical',
    group: 'emergency_pharma',
    severity_level: 'F',
    severity_score: 3,
    category: 'การใช้ยาและสารเคมีทางทันตกรรม',
    sub_category: 'สารกัดกร่อน (Etchant/Sodium Hypochlorite) สัมผัสเนื้อเยื่ออ่อนหรือตา',
    location: 'คลีนิกห้อง 1',
    is_patient_involved: false,
    is_frequent: false,
    keywords: ['naocl accident', 'ทะลุปลายราก', 'ปวดเฉียบพลัน', 'โซเดียมไฮโป', 'บวมเฉียบพลัน']
  },
  {
    id: 'cardiac-arrest',
    tag: 'ผู้ป่วยหัวใจหยุดเต้น (Cardiac Arrest)',
    domain: 'clinical',
    group: 'emergency_pharma',
    severity_level: 'I',
    severity_score: 5,
    category: 'ภาวะฉุกเฉินทางการแพทย์ในคลินิก',
    sub_category: 'ผู้ป่วยชักเกร็ง / หยุดหายใจ',
    location: 'คลีนิกห้อง 1',
    is_patient_involved: false,
    is_frequent: false,
    keywords: ['หัวใจหยุดเต้น', 'cardiac arrest', 'cpr', 'aed', 'ช่วยชีวิต', 'ไม่หายใจ']
  },

  // ==========================================
  // หมวด 4: ความปลอดภัยบุคลากร & สิ่งแวดล้อม (Staff Safety)
  // ==========================================
  {
    id: 'needle-stick',
    tag: 'เข็มตำ/ของมีคมบาด',
    domain: 'non_clinical',
    group: 'staff_safety',
    severity_level: '3',
    severity_score: 3,
    category: 'ความปลอดภัยและสิ่งแวดล้อม (Safety & Environment)',
    sub_category: 'อุบัติเหตุของมีคม / เข็มตำบุคลากร (Needle Stick Injury)',
    location: 'คลีนิกห้อง 1',
    is_patient_involved: false,
    is_frequent: true,
    keywords: ['เข็มตำ', 'ของมีคม', 'บาด', 'needle stick', 'sharp', 'เข็ม', 'ทิ่มนิ้ว']
  },
  {
    id: 'blood-splash-eye',
    tag: 'เลือดกระเด็นเข้าตา/เยื่อบุ',
    domain: 'non_clinical',
    group: 'staff_safety',
    severity_level: '2',
    severity_score: 2,
    category: 'ความปลอดภัยและสิ่งแวดล้อม (Safety & Environment)',
    sub_category: 'สารคัดหลั่งหรือเลือดกระเด็นใส่ตา/ผิวหนัง (Splash injury)',
    location: 'คลีนิกห้อง 1',
    is_patient_involved: false,
    is_frequent: true,
    keywords: ['เลือดกระเด็น', 'เข้าตา', 'splash', 'สารคัดหลั่ง', 'เยื่อบุ', 'กระเด็น']
  },
  {
    id: 'slip-trip-fall',
    tag: 'น้ำรั่วซึม/พื้นลื่น/หกล้ม',
    domain: 'non_clinical',
    group: 'staff_safety',
    severity_level: '2',
    severity_score: 2,
    category: 'ความปลอดภัยและสิ่งแวดล้อม (Safety & Environment)',
    sub_category: 'ลื่นหกล้ม / สะดุดสายไฟในคลินิก',
    location: 'ไม่ระบุ',
    is_patient_involved: false,
    is_frequent: true,
    keywords: ['พื้นลื่น', 'หกล้ม', 'สะดุด', 'slip', 'fall', 'trip', 'ลื่น', 'น้ำหก']
  },
  {
    id: 'chemical-spill',
    tag: 'สารเคมีอันตรายหกหล่นรั่วซึม',
    domain: 'non_clinical',
    group: 'staff_safety',
    severity_level: '2',
    severity_score: 2,
    category: 'ความปลอดภัยและสิ่งแวดล้อม (Safety & Environment)',
    sub_category: 'สารเคมีอันตรายหกหล่นรั่วซึม',
    location: 'จุดล้างและทำลายเชื้อ',
    is_patient_involved: false,
    is_frequent: false,
    keywords: ['สารเคมีหก', 'รั่วซึม', 'chemical spill', 'น้ำยาหก', 'หกเลอะ']
  },
  {
    id: 'fire-exit-blocked',
    tag: 'ทางหนีไฟหรือถังดับเพลิงมีสิ่งกีดขวาง',
    domain: 'non_clinical',
    group: 'staff_safety',
    severity_level: '1',
    severity_score: 1,
    category: 'ความปลอดภัยและสิ่งแวดล้อม (Safety & Environment)',
    sub_category: 'อุปกรณ์ดับเพลิงหรือทางหนีไฟมีสิ่งกีดขวาง',
    location: 'ไม่ระบุ',
    is_patient_involved: false,
    is_frequent: false,
    keywords: ['ทางหนีไฟ', 'ดับเพลิง', 'กีดขวาง', 'fire exit', 'ทางออกฉุกเฉิน']
  },
  {
    id: 'staff-burn-heat',
    tag: 'ความร้อนด้ามซีล/เตาอบลวกมือบุคลากร',
    domain: 'non_clinical',
    group: 'staff_safety',
    severity_level: '3',
    severity_score: 3,
    category: 'ความปลอดภัยและสิ่งแวดล้อม (Safety & Environment)',
    sub_category: 'สารคัดหลั่งหรือเลือดกระเด็นใส่ตา/ผิวหนัง (Splash injury)',
    location: 'ห้องจ่ายกลาง (CSSD)',
    is_patient_involved: false,
    is_frequent: false,
    keywords: ['ลวก', 'ความร้อน', 'ซีล', 'burn staff', 'เครื่องซีล', 'เตาอบ']
  },
  {
    id: 'vapor-inhalation',
    tag: 'สูดดมไอระเหยสารเคมีหรือฝุ่นกรอฟัน',
    domain: 'non_clinical',
    group: 'staff_safety',
    severity_level: '2',
    severity_score: 2,
    category: 'ความปลอดภัยและสิ่งแวดล้อม (Safety & Environment)',
    sub_category: 'สารเคมีอันตรายหกหล่นรั่วซึม',
    location: 'คลีนิกห้อง 1',
    is_patient_involved: false,
    is_frequent: false,
    keywords: ['ไอระเหย', 'ฝุ่นกรอ', 'กลิ่นสารเคมี', 'vapor', 'fumes', 'สูดดม']
  },
  {
    id: 'ergonomics-strain',
    tag: 'บุคลากรบาดเจ็บกล้ามเนื้อจากการยศาสตร์',
    domain: 'non_clinical',
    group: 'staff_safety',
    severity_level: '2',
    severity_score: 2,
    category: 'ความปลอดภัยและสิ่งแวดล้อม (Safety & Environment)',
    sub_category: 'ลื่นหกล้ม / สะดุดสายไฟในคลินิก',
    location: 'ไม่ระบุ',
    is_patient_involved: false,
    is_frequent: false,
    keywords: ['การยศาสตร์', 'ปวดหลัง', 'กล้ามเนื้อ', 'ergonomics', 'strain', 'ยกของหนัก']
  },

  // ==========================================
  // หมวด 5: อุปกรณ์ & ระบบสาธารณูปโภค (Equipment & Systems)
  // ==========================================
  {
    id: 'dental-unit-malfunction',
    tag: 'อุปกรณ์/ยูนิตขัดข้อง',
    domain: 'non_clinical',
    group: 'equipment_system',
    severity_level: '2',
    severity_score: 2,
    category: 'ระบบสาธารณูปโภคและโครงสร้างพื้นฐาน',
    sub_category: 'อุปกรณ์/ยูนิตทำฟันขัดข้อง (Dental Unit Malfunction)',
    location: 'คลีนิกห้อง 1',
    is_patient_involved: false,
    is_frequent: true,
    keywords: ['ยูนิต', 'ขัดข้อง', 'dental unit', 'เก้าอี้ทำฟัน', 'ไฟส่อง', 'แป้นเหยียบ']
  },
  {
    id: 'power-outage',
    tag: 'ไฟฟ้าดับ/ระบบสำรองไฟขัดข้อง',
    domain: 'non_clinical',
    group: 'equipment_system',
    severity_level: '3',
    severity_score: 3,
    category: 'ระบบสาธารณูปโภคและโครงสร้างพื้นฐาน',
    sub_category: 'ไฟฟ้าดับ / ระบบสำรองไฟขัดข้อง',
    location: 'ไม่ระบุ',
    is_patient_involved: false,
    is_frequent: true,
    keywords: ['ไฟดับ', 'ไฟฟ้าดับ', 'ไฟกระตุก', 'power outage', 'ไฟสำรอง', 'ups']
  },
  {
    id: 'air-compressor-failure',
    tag: 'ปั๊มลม Dental Compressor ดับ/รั่ว',
    domain: 'non_clinical',
    group: 'equipment_system',
    severity_level: '3',
    severity_score: 3,
    category: 'ระบบสาธารณูปโภคและโครงสร้างพื้นฐาน',
    sub_category: 'ระบบลม Dental Air Compressor ดับ/รั่วซึม',
    location: 'ไม่ระบุ',
    is_patient_involved: false,
    is_frequent: true,
    keywords: ['ปั๊มลม', 'compressor', 'ลมรั่ว', 'ลมตก', 'air compressor', 'ไม่มีลม']
  },
  {
    id: 'central-suction-failure',
    tag: 'ระบบดูดเสมหะส่วนกลาง (Central Suction) ขัดข้อง',
    domain: 'non_clinical',
    group: 'equipment_system',
    severity_level: '3',
    severity_score: 3,
    category: 'ระบบสาธารณูปโภคและโครงสร้างพื้นฐาน',
    sub_category: 'ระบบดูดเสมหะส่วนกลาง (Central Suction) ขัดข้อง',
    location: 'ไม่ระบุ',
    is_patient_involved: false,
    is_frequent: true,
    keywords: ['suction', 'ดูดน้ำลาย', 'ซักชั่นดับ', 'central suction', 'แรงดูดตก']
  },
  {
    id: 'water-supply-failure',
    tag: 'ระบบจ่ายน้ำประปา/น้ำ RO ขัดข้อง',
    domain: 'non_clinical',
    group: 'equipment_system',
    severity_level: '2',
    severity_score: 2,
    category: 'ระบบสาธารณูปโภคและโครงสร้างพื้นฐาน',
    sub_category: 'ระบบจ่ายน้ำประปา / น้ำ RO ขัดข้อง',
    location: 'ไม่ระบุ',
    is_patient_involved: false,
    is_frequent: false,
    keywords: ['น้ำไม่ไหล', 'น้ำro', 'ระบบน้ำ', 'water supply', 'ท่อน้ำตัน']
  },
  {
    id: 'network-emr-down',
    tag: 'ระบบเน็ตเวิร์ก/อินเทอร์เน็ตล่ม (EMR Down)',
    domain: 'non_clinical',
    group: 'equipment_system',
    severity_level: '2',
    severity_score: 2,
    category: 'ระบบสารสนเทศและเวชระเบียน',
    sub_category: 'ระบบเครือข่ายอินเทอร์เน็ตล่ม ไม่สามารถดูชาร์ตได้',
    location: 'ไม่ระบุ',
    is_patient_involved: false,
    is_frequent: false,
    keywords: ['เน็ตหลุด', 'เน็ตล่ม', 'internet', 'network', 'เปิดชาร์ตไม่ได้', 'emr down']
  },
  {
    id: 'pc-crash-data-loss',
    tag: 'คอมพิวเตอร์ดับ/ข้อมูลสูญหาย',
    domain: 'non_clinical',
    group: 'equipment_system',
    severity_level: '2',
    severity_score: 2,
    category: 'ระบบสารสนเทศและเวชระเบียน',
    sub_category: 'เครื่องคอมพิวเตอร์ประจำยูนิตดับขณะลงข้อมูล',
    location: 'คลีนิกห้อง 1',
    is_patient_involved: false,
    is_frequent: false,
    keywords: ['คอมดับ', 'ข้อมูลหาย', 'computer crash', 'pc', 'จอฟ้า']
  },
  {
    id: 'digital-xray-sensor-broken',
    tag: 'เครื่องเอกซเรย์/เซนเซอร์ชำรุด',
    domain: 'non_clinical',
    group: 'equipment_system',
    severity_level: '2',
    severity_score: 2,
    category: 'ระบบสาธารณูปโภคและโครงสร้างพื้นฐาน',
    sub_category: 'อุปกรณ์/ยูนิตทำฟันขัดข้อง (Dental Unit Malfunction)',
    location: 'ห้อง X-Ray / CT',
    is_patient_involved: false,
    is_frequent: false,
    keywords: ['xray', 'sensor', 'เซนเซอร์พัง', 'เครื่องเอกซเรย์', 'สายขาด']
  },
  {
    id: 'duwl-contamination',
    tag: 'น้ำในระบบยูนิตทำฟันปนเปื้อน (DUWL)',
    domain: 'clinical',
    group: 'equipment_system',
    severity_level: 'C',
    severity_score: 2,
    category: 'การควบคุมการติดเชื้อและการสเตอไรล์ (Infection Control)',
    sub_category: 'น้ำในระบบยูนิตทำฟันปนเปื้อน',
    location: 'คลีนิกห้อง 1',
    is_patient_involved: false,
    is_frequent: false,
    keywords: ['duwl', 'น้ำปนเปื้อน', 'เชื้อโรคในน้ำ', 'waterline', 'ท่อน้ำยูนิต']
  },
  {
    id: 'hvac-air-conditioning-failure',
    tag: 'เครื่องปรับอากาศ/ระบบระบายอากาศเสีย',
    domain: 'non_clinical',
    group: 'equipment_system',
    severity_level: '2',
    severity_score: 2,
    category: 'ระบบสาธารณูปโภคและโครงสร้างพื้นฐาน',
    sub_category: 'เครื่องปรับอากาศหรือระบบระบายอากาศชำรุด',
    location: 'ไม่ระบุ',
    is_patient_involved: false,
    is_frequent: false,
    keywords: ['แอร์เสีย', 'แอร์ไม่เย็น', 'ระบายอากาศ', 'hvac', 'air con', 'แอร์น้ำหยด']
  }
];

/**
 * รายการแท็กเหตุการณ์พบบ่อย (Common Incident Tags)
 * รักษาความเข้ากันได้ย้อนหลัง (Backward Compatibility)
 */
export const COMMON_INCIDENT_TAGS = COMPREHENSIVE_DENTAL_INCIDENTS
  .filter((item) => item.is_frequent)
  .map((item) => item.tag);

/**
 * เกณฑ์ตั้งต้นสำหรับเหตุการณ์พบบ่อย (Incident Criteria Presets)
 * ใช้สำหรับ Auto-fill ข้อมูลตามหลักเวชปฏิบัติและงานจ่ายกลาง (CSSD & Clinical Criteria)
 */
const buildIncidentPresets = () => {
  const presets = {};

  // 1. ลงทะเบียนเหตุการณ์ทั้งหมดจาก COMPREHENSIVE_DENTAL_INCIDENTS
  COMPREHENSIVE_DENTAL_INCIDENTS.forEach((item) => {
    presets[item.tag] = {
      domain: item.domain,
      severity_level: item.severity_level,
      severity_score: item.severity_score,
      category: item.category,
      sub_category: item.sub_category,
      location: item.location || 'ไม่ระบุ',
      is_patient_involved: Boolean(item.is_patient_involved),
      group: item.group,
      is_frequent: item.is_frequent
    };
  });

  // 2. เผื่อชื่อเล่นหรือแท็กเก่าสำหรับ Backward Compatibility
  const legacyAliases = {
    'ไซนัสทะลุ (OAC)': presets['ไซนัสทะลุ (OAC - Oroantral Communication)'],
    'หัวกรอหัก': presets['หัวกรอหัก/ด้ามกรอชำรุดขณะใช้งาน'],
    'แผลไหม้จากด้ามหัวกรอ': presets['แผลไหม้จากด้ามหัวกรอ (Handpiece Burn)'],
    'สิ่งแปลกปลอมหลุดลงคอ/สำลัก': presets['สิ่งแปลกปลอมหลุดลงคอ/สำลัก (Aspiration)'],
    'ยาชาผิดปกติ/แพ้ยา': presets['ผู้ป่วยแพ้ยาชา/แพ้ยารุนแรง (Anaphylaxis)'],
    'สารเคมี/กรดกัดกร่อน': presets['สารเคมี/กรดกัดกร่อน (Etchant/NaOCl)'],
    'Autoclave ฟาวล์': presets['Autoclave ฟาวล์/ตัดกลางคัน'],
    'น้ำรั่วซึม/พื้นลื่น': presets['น้ำรั่วซึม/พื้นลื่น/หกล้ม'],
    'เลือดกระเด็นเข้าตา': presets['เลือดกระเด็นเข้าตา/เยื่อบุ']
  };

  Object.entries(legacyAliases).forEach(([alias, presetData]) => {
    if (presetData && !presets[alias]) {
      presets[alias] = presetData;
    }
  });

  return presets;
};

export const INCIDENT_CRITERIA_PRESETS = buildIncidentPresets();



